import { API_EXPRESS_URLS, APP_ENVIROMENT, APP_ENVIROMENT_TYPE } from './types';

const APP_ENVIRONMENT = {
  DEVELOPMENT: APP_ENVIROMENT.DEVELOPMENT,
  STAGING: APP_ENVIROMENT.STAGING,
  SANDBOX: APP_ENVIROMENT.SANDBOX,
  PRODUCTION: APP_ENVIROMENT.PRODUCTION,
  SUSTAINING: APP_ENVIROMENT.SUSTAINING,
};

const API_EXPRESS_ENVIRONMENTS = {
  defaultValue: API_EXPRESS_URLS.DEVELOPMENT,
  development: API_EXPRESS_URLS.DEVELOPMENT,
  staging: API_EXPRESS_URLS.STAGING,
  sandbox: API_EXPRESS_URLS.SANDBOX,
  sustaining: API_EXPRESS_URLS.SUSTAINING,
  production: API_EXPRESS_URLS.PRODUCTION,
};

const getEnv = (env: string) =>
  process.env.REACT_APP_ENV ===
  (APP_ENVIRONMENT as Record<string, string>)[env];

const isEnvDevelopment =
  !process.env.REACT_APP_ENV || getEnv(APP_ENVIROMENT.DEVELOPMENT);
const isEnvStaging = getEnv(APP_ENVIROMENT.STAGING);
const isEnvSandbox = getEnv(APP_ENVIROMENT.SANDBOX);
const isEnvProduction = getEnv(APP_ENVIROMENT.PRODUCTION);
const isEnvSustaining = getEnv(APP_ENVIROMENT.SUSTAINING);

const getCurrentEnvExpressApiUrl = (): string => {
  const env = process.env.REACT_APP_ENV || APP_ENVIRONMENT.DEVELOPMENT;
  return getEnvExpressApiUrl(env);
};

const getEnvExpressApiUrl = (env: APP_ENVIROMENT_TYPE | string): string => {
  return API_EXPRESS_ENVIRONMENTS[env] || API_EXPRESS_ENVIRONMENTS.defaultValue;
};

export {
  isEnvDevelopment,
  isEnvStaging,
  isEnvSandbox,
  isEnvProduction,
  isEnvSustaining,
  getCurrentEnvExpressApiUrl,
  getEnvExpressApiUrl,
};
